import { render } from "./orderImport.vue?vue&type=template&id=31ffe3cc&scoped=true"
import script from "./orderImport.vue?vue&type=script&lang=js"
export * from "./orderImport.vue?vue&type=script&lang=js"

import "./orderImport.vue?vue&type=style&index=0&id=31ffe3cc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ffe3cc"]])

export default __exports__